const residenceType = Object.freeze({
    COMPLEX: 0,
    SIMPLIFIED: 1,
    BASIC: 2
});

export default residenceType;